import game from "./game.json";
export default game;
